import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "15",
  viewBox: "0 0 16 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M8.40923 9.00647H2.59616V6.67665H8.40923C8.74879 6.67665 8.98488 6.73659 9.10337 6.84127C9.22186 6.94596 9.29525 7.14011 9.29525 7.42373V8.26028C9.29525 8.55911 9.22186 8.75326 9.10337 8.85794C8.98488 8.96263 8.74879 9.00736 8.40923 9.00736V9.00647ZM8.80803 4.48014H0.130859V14.4436H2.59616V11.2021H7.13945L9.29525 14.4436H12.0559L9.67902 11.1869C10.5553 11.0553 10.9488 10.7834 11.2733 10.3351C11.5978 9.88686 11.7606 9.1702 11.7606 8.21376V7.46667C11.7606 6.89943 11.7013 6.45118 11.5978 6.10761C11.4944 5.76405 11.3175 5.46522 11.0664 5.1968C10.8011 4.94271 10.5058 4.76376 10.1512 4.64387C9.79663 4.53919 9.35361 4.47925 8.80803 4.47925V4.48014Z",
      fill: "white"
    }, null, -1),
    _createElementVNode("path", {
      d: "M13.9506 4.4792C14.9966 4.4792 15.8446 3.63095 15.8446 2.58457C15.8446 1.5382 14.9966 0.689941 13.9506 0.689941C12.9046 0.689941 12.0566 1.5382 12.0566 2.58457C12.0566 3.63095 12.9046 4.4792 13.9506 4.4792Z",
      fill: "#ED143B"
    }, null, -1)
  ])))
}
export default { render: render }